import React, { useState } from "react";
import { Container, Grid } from "@mui/material";
import { DelendMaskedField } from "../../../components/TextFields";
import DelendBankSelection from "../../../components/Select/BankSelection";
import { FetchParticipants } from "../../../hooks";
import ConsentService from "../../../services/ConsentService";
import DelendCentralizedCircularProgress from "../../../components/CircularProgress/DelendCentralizedCircularProgress";
import { Add } from "@mui/icons-material";
import { DelendButton } from "../../../components/Buttons";

const CreateNaturalPersonConsent = (props) => {
  const [naturalPersonConsent, setNaturalPersonConsent] = useState({
    documentNumber: (props && props.preFill && props.preFill.documentNumber) ? props.preFill.documentNumber : "",
    mobilePhone: (props && props.preFill && props.preFill.mobilePhone) ? props.preFill.mobilePhone : "" ,
    brands: [],
  });

  const { status, data } = FetchParticipants("personal");

  const [isLoading, setLoading] = useState(false);

  const handleChange = (event) => {
    if (event.target.name === "brands") {
      const brand = [event.target.value];
      setNaturalPersonConsent({
        ...naturalPersonConsent,
        [event.target.name]: brand,
      });
      return;
    }

    setNaturalPersonConsent({
      ...naturalPersonConsent,
      [event.target.name]: event.target.value.replace(/\D/g, ""),
    });
  };

  const cleanFields = () => {
    setNaturalPersonConsent({
      documentNumber: "",
      mobilePhone: "",
      brands: [],
    });
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    setLoading(true);
    const response = await ConsentService.create(naturalPersonConsent);
    if (response.status === 200) {
      cleanFields();
    }
    setLoading(false);
    props.handleDrawerClose();
  };

  if (status !== "fetched") {
    return <DelendCentralizedCircularProgress absolute="true"/>;
  }

  if (isLoading) {
    return <DelendCentralizedCircularProgress absolute="true"/>;
  }

  return (
    <Container component="main" maxWidth="md" sx={{ mb: 4 }}>
      <React.Fragment>
        <form onSubmit={handleSubmit}>
          <Grid container spacing={5}>
            <Grid item xs={12} sm={6}>
              <DelendMaskedField
                label="CPF"
                mask="999.999.999-99"
                variant="standard"
                name="documentNumber"
                value={naturalPersonConsent.documentNumber}
                onChange={handleChange}
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <DelendMaskedField
                label="Celular"
                mask="55 (99) 99999-9999"
                variant="standard"
                name="mobilePhone"
                value={naturalPersonConsent.mobilePhone}
                onChange={handleChange}
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <DelendBankSelection handleChange={handleChange} value={data} />
            </Grid>
            <Grid item xs={12}>
              <DelendButton
                text={"Solicitar Open Finance"}
                fullWidth={true}
                startIcon={<Add />}
                padding={"12px 0px"}
              />
            </Grid>
          </Grid>
        </form>
      </React.Fragment>
    </Container>
  );
};

export default CreateNaturalPersonConsent;
